var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "container-main",
        _vm.sourceForm === _vm.SOURCEFORM_TMBD ? "tmBd-main" : "common-main",
      ],
      style: {
        marginTop: _vm.marginTopProps ? _vm.marginTopProps : "auto",
        paddingTop: _vm.paddingTopProps ? _vm.paddingTopProps : "auto",
        background: _vm.backgroundProps ? _vm.backgroundProps : "#ffffff",
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }